export const ESTADO_EN_DEVOLUCION = 'en-devolucion'
export const ESTADO_DEVOLUCION_VERIFICADA = 'devolucion_verificada'
export const ESTADO_DEVOLUCION_INCOMPLETA = 'devolucion_incompleta'
export const ESTADO_DEVOLUCION_INCOMPLETA_POR_NC = 'devolucion_incompleta_por_nc'
export const ESTADO_DEVOLUCION_CON_FALTANTES = 'devolucion_con_faltantes'
export const ESTADO_VERIFICAR_DEVOLUCION = 'verificar_devolucion'
export const ESTADO_DEVOLUCION_PARA_TRANSFERIR = 'devolucion_para_transferir'

/** Estados que alimentan la lista de Devoluciones para transferir */
export const ESTADOS_DEVOLUCIONES_PARA_TRANSFERIR = [
  ESTADO_DEVOLUCION_VERIFICADA,
  ESTADO_DEVOLUCION_INCOMPLETA,
  ESTADO_DEVOLUCION_INCOMPLETA_POR_NC,
  ESTADO_DEVOLUCION_PARA_TRANSFERIR
] as const

export type EstadoUnidadDevolucion = 'buen_estado' | 'mal_estado'

export type TipoUnidadEmpaque = 'bolsa' | 'caja' | 'wacal'

export interface UnidadEmpaqueItem {
  tipo: TipoUnidadEmpaque
  cantidad: number
}

export type UnidadesEmpaqueRecibidas = Record<TipoUnidadEmpaque, number>

/** Estructura anidada: empacado original (array o clave) + devolucion */
export interface UnidadesEmpaqueNested {
  devolucion?: UnidadEmpaqueItem[]
  despacho?: UnidadEmpaqueItem[]
  envio?: UnidadEmpaqueItem[]
  original?: UnidadEmpaqueItem[]
  empacado?: UnidadEmpaqueItem[]
  empaque?: UnidadEmpaqueItem[]
  [key: string]: UnidadEmpaqueItem[] | undefined
}

export type UnidadesEmpaqueValue = UnidadEmpaqueItem[] | UnidadesEmpaqueNested

export interface DevolucionOrderListItem {
  id: number
  orders_id?: string | number
  customer_full_name?: string
  date_created?: string
  store_name?: string
  status: string
  total?: string
}

export interface DevolucionOrderCustomer {
  first_name?: string
  last_name?: string
  email?: string
  document?: string
  tipo_documento?: string
  tipo_persona?: string
}

export interface DevolucionOrderAddress {
  address_1?: string
  address_2?: string
  city?: string
  state?: string
  country?: string
  postcode?: string
  phone?: string
}

export interface DevolucionOrderExtraDetails {
  forma_pago?: string
  payment_method?: string
  customer_note?: string
  transportadora?: string
  transaction_id?: string
  unidades_empaque?: UnidadesEmpaqueValue
}

export interface DevolucionOrderLineItem {
  product_id: string
  product_name: string
  quantity: number
  price?: string
  sku?: string
}

export interface DevolucionOrderDetail {
  id: number
  orders_id?: number | string
  origin_order_id?: number
  store_name?: string
  status: string
  total?: string
  envio?: string
  guia?: string
  date_created?: string
  date_modified?: string
  payment_method?: string
  unidades_empaque?: UnidadesEmpaqueValue
  extraDetails?: DevolucionOrderExtraDetails
  customer?: DevolucionOrderCustomer
  billingAddress?: DevolucionOrderAddress
  shippingAddress?: DevolucionOrderAddress
  lineItems?: DevolucionOrderLineItem[]
}

export interface DevolucionUnitLine {
  id: string
  sku: string
  producto: string
  sourceIndex: number
  unitIndex: number
}

export type DevolucionUnitSelections = Record<string, EstadoUnidadDevolucion>

export interface CoberturaTrasladoItem {
  sku: string
  nombre?: string
  expected: number
  approved: number
  reserved?: number
  pending: number
  availableForTransfer?: number
  canCreateTransfer?: boolean
  /** true si approved > 0 */
  hasApprovedTransfer?: boolean
  transferencia_aprobada?: boolean
  /** true si hay traslado pendiente y/o aprobado para este SKU */
  hasAnyTransfer?: boolean
  tiene_transferencia?: boolean
  /** true si no hay ninguna transferencia asociada (ni pendiente ni aprobada) */
  sin_transferencia?: boolean
  hasNoTransfer?: boolean
  /** true si approved >= expected */
  fullyApproved?: boolean
  approvedTransfers?: Array<{
    id: number
    idorder?: string
    consecutivo?: string
    fecha_aprobacion?: string | null
    cantidad: number
    producto?: string | null
  }>
  blockedReason?: string | null
  precio?: number
  ncErrors?: unknown[]
}

export interface CoberturaTrasladoLinea {
  sku: string
  cantidad: number
  producto?: string
}

export interface CoberturaTrasladoTransfer {
  id: number
  idorder?: string
  estado: string
  consecutivo?: string
  fecha_aprobacion?: string | null
  lineas?: CoberturaTrasladoLinea[]
}

export interface CoberturaTrasladoBlockedSku {
  sku: string
  reason?: string
  expected?: number
  reserved?: number
  approved?: number
  availableForTransfer?: number
  message?: string
}

export interface CoberturaTrasladoMissingSku {
  sku: string
  pending?: number
  expected?: number
  approved?: number
}

export interface CoberturaTrasladoOfima {
  fs?: string
  nc?: string
  nc_es_parcial?: number
  nc_partial_skus?: string[]
  nc_historial?: Array<{
    nc?: string
    parcial?: boolean
    skus?: string[]
    transferId?: number
    at?: string
  }>
  nc_error_detalle?: unknown[]
}

export interface CoberturaTrasladosData {
  orderId: number
  id_pedido_sistema?: string
  estado_pedido?: string
  complete: boolean
  suggestedStatus?: string
  canCreateAnyTransfer?: boolean
  items: CoberturaTrasladoItem[]
  /** Productos del pedido con al menos una ud. en traslado aprobado */
  productos_con_transferencia_aprobada?: Array<{
    sku: string
    nombre?: string | null
    expected: number
    approved: number
    pending: number
    fullyApproved?: boolean
    approvedTransfers?: CoberturaTrasladoItem['approvedTransfers']
  }>
  /** Productos del pedido sin ningún traslado asociado (pendiente/aprobado) */
  productos_sin_transferencia?: Array<{
    sku: string
    nombre?: string | null
    expected: number
    approved: number
    reserved?: number
    pending: number
  }>
  missingSkus?: Array<string | CoberturaTrasladoMissingSku>
  blockedSkus?: CoberturaTrasladoBlockedSku[]
  transfers?: CoberturaTrasladoTransfer[]
  ofima?: CoberturaTrasladoOfima
}

export interface CoberturaTrasladosResponse {
  success?: boolean
  data: CoberturaTrasladosData
  message?: string
}
